import { call, put, takeLatest, all } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API";
import {
  fetchPowerBIEmbedConfigSuccess,
  fetchPowerBIEmbedConfigFailure,
  refreshPowerBIEmbedTokenSuccess,
  refreshPowerBIEmbedTokenFailure,
} from "./actions";

// Initial fetch
function* fetchPowerBIEmbedConfigSaga(action) {
  const { keyword } = action;
  try {
    const { data } = yield call(API.get, `/powerbi/embed-config?keyword=${keyword}`);
    if (data.success) {
      yield put(fetchPowerBIEmbedConfigSuccess(keyword, data.data));
    } else {
      yield put(fetchPowerBIEmbedConfigFailure(data.message || "Failed to load Power BI config"));
    }
  } catch (error) {
    const message = error?.response?.data?.message || error.message || "Unexpected error";
    yield put(fetchPowerBIEmbedConfigFailure(message));
  }
}

// Refresh token
function* refreshPowerBIEmbedTokenSaga() {
  try {
    const { data } = yield call(API.get, "/powerbi/refresh-pbi-token");
    if (data.success) {
      yield put(refreshPowerBIEmbedTokenSuccess(data.data.embedToken));
    } else {
      yield put(refreshPowerBIEmbedTokenFailure(data.message || "Failed to refresh token"));
    }
  } catch (error) {
    const message = error?.response?.data?.message || error.message || "Unexpected error";
    yield put(refreshPowerBIEmbedTokenFailure(message));
  }
}

function* PowerBISaga() {
  yield all([
    takeLatest(actionTypes.FETCH_POWERBI_EMBED_CONFIG, fetchPowerBIEmbedConfigSaga),
    takeLatest(actionTypes.REFRESH_POWERBI_EMBED_TOKEN, refreshPowerBIEmbedTokenSaga),
  ]);
}

export default PowerBISaga;
